import React from 'react';
import {withRouter} from 'react-router'
import {getPolicyConsult} from "./service";
import AdBanner from "../../common/AdBanner/AdBanner";
import PolicyAnalyzeCard from "../../common/PolicyAnalyzeCard/PolicyAnalyzeCard";
import InterestSearchTag from "../../common/InterestSearchTag/InterestSearchTag";
import HotRank from "../../common/HotRank/HotRank";
import LatestNews from "../../common/LatestNews/LatestNews";
import PaginationList from "../../common/Paginator/PaginationList";
import ContentReserver from "../Content/contentReserve";
import style from './AboutPolicy.module.css';

const AboutPolicy = (props) => {
    const { history } = props;

    const onMoreClick = item => {
        const { id, title } = item;
        window.scrollTo(0,400);
        history.push(`/policy/more/${id}/${title}`);
    };

    return (
        <div style={{width: 1200, display: 'flex', flexDirection: 'column',alignItems: 'center', justifyContent:'center'}}>
            <div style={{display:'flex',flexDirection:'row'}}>
                <div style={{width: '100%'}}>
                    <PaginationList
                        style={{background: '#f0f2f5'}}
                        title={null}
                        url="/api/PolicyCate"
                        hidePagination
                        renderItem={item => {
                            const { id, title, photo_link, children } = item;
                            return (
                                <div key={id} style={{width: 912}}>
                                    <div className={style.title}>
                                        {title}
                                        <span className={style.moreButton}  onClick={() => {onMoreClick(item)}}>更多 >></span>
                                    </div>
                                    <div className={style.itemBody}>
                                        <img src={photo_link} style={{width: 400, height: 200}}/>
                                        <div className={style.newsWrapper}>
                                            {
                                                children.map((item, index) => {
                                                    return (
                                                        index < 5
                                                        ?   <div key={index} style={{fontSize: 16}} onClick={()=>{history.push(`/policy/more/${item.cate_id}/${item.cate_desc}/detail/${item.id}`)}}>
                                                                <img src={require('../../images/rectangle4.png')} style={{marginRight: 8, width: 8, height: 8}}/>
                                                                <span style={{cursor: 'pointer'}}>{item.title}</span>
                                                            </div>
                                                        :   null
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            );
                        }}
                        onGetDataFinish={async (policyCateData) => {
                            const { data } = await getPolicyConsult();
                            policyCateData.list.map(policyCateItem => {
                                policyCateItem.children = data.list.filter(policyConsultItem => {
                                    if (policyConsultItem.cate_id === policyCateItem.id) {
                                        return policyConsultItem
                                    }
                                });
                            });
                            // 按照数据库中的sort字段进行排序
                            policyCateData.list.sort((item1,item2)=>{
                                return item1.sort-item2.sort;
                            });
                            return policyCateData
                        }}
                    />

                    <AdBanner width={912} height={113}/>
                    <div style={{height: 16}}/>
                    <PolicyAnalyzeCard/>
                </div>
                <div style={{marginLeft: 16}}>
                    <InterestSearchTag/>
                    <div style={{height: 16}}/>
                    <HotRank/>
                    <div style={{height: 16}}/>
                    <LatestNews/>
                </div>
            </div>
            <div style={{height: 16}}></div>
            <ContentReserver />
        </div>
    );
};

export default withRouter(AboutPolicy);
